import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["fill"];
const _hoisted_2 = ["xlink:href"];
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
export default {
  __name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    },
    prefix: {
      type: String,
      default: 'icon'
    },
    size: {
      type: String,
      default: '20px'
    },
    color: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    const store = useStore();
    const isDark = computed(() => store.state.theme === "dark");
    const props = __props;
    const getFillColor = () => {
      if (props.color) {
        return props.color;
      }
      return isDark.value ? "#999" : "#666";
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", {
        "aria-hidden": "true",
        style: _normalizeStyle({
          width: __props.size,
          height: __props.size
        }),
        class: "icon",
        fill: getFillColor()
      }, [_createElementVNode("use", {
        "xlink:href": `#${__props.prefix}-${__props.name}`
      }, null, 8, _hoisted_2)], 12, _hoisted_1);
    };
  }
};